// src/components/general/Management.jsx

import React, { useCallback, useState } from "react";
import { Button, App } from "antd";
import BaseForm from "./BaseForm";
import BaseList from "./BaseList";
import API from "API";
import dayjs from "dayjs";
import "./style.css";

const Management = ({
    layout = [],
    apiPath = "",
    itemName = "mục",
    columns = [],
    listMode = "table",
    fetchData: fetchDataProp,
    additionalPostData = {},
    onReload = null,
    useFrontendPagination = false,
    onCardClick = null,
    disableSearch = false,
    customActions = null,
    defaultLogo = "",
    actions = null,
    expandable = null,
    excelImportExportOptions = null,
    onTableClick = null,
    renderContentCard = null,
    dateFields = [],
    setDataObject = null,
    onSubmitError = null,
    noChange = false,
    tranformData=null,
}) => {
    const [editingItem, setEditingItem] = useState(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [reloadKey, setReloadKey] = useState(0);
    const { message } = App.useApp();

    const handleOpenModal = (item = null) => {
        setEditingItem(item);
        setIsModalVisible(true);
    };

    const handleCloseModal = () => {
        setEditingItem(null);
        setIsModalVisible(false);
    };

    const reloadList = () => {
        setReloadKey((prev) => prev + 1);
        if (onReload) onReload();
    };

    const handleDelete = async (id) => {
        try {
            await API.delete(`${apiPath}${id}/`);
            message.success(`Đã xóa ${itemName}`);
            reloadList();
        } catch (err) {
            message.error(`Không thể xóa ${itemName}`);
        }
    };

    const fetchData = useCallback(fetchDataProp || (async ({ searchTerm, page, pageSize }) => {
        if (setDataObject) {
            setDataObject({loading: true});
        }

        const response = await API.get(apiPath, {
            params: {
                search: searchTerm,
                page: page || 1,
                page_size: pageSize || 10,
            },
        });

        for (const r of response.data.results) {
            for (const f of dateFields) {
                const field = f.field
                r[field] = r[field] && dayjs(r[field]);
            }
        }

        if (setDataObject) {
            setDataObject({loading: false, data: response.data});
        }

        return {
            data: tranformData ? response.data.results.map(tranformData) : response.data.results,
            total: response.data.count,
        };
    }), [fetchDataProp, apiPath]);

    const actionGroup = (
        <>
            <Button type="primary" onClick={() => handleOpenModal()}>
                Thêm {itemName}
            </Button>
            {typeof actions === "function" ? actions({ onReloadList: reloadList }) : actions}
        </>
    );

    return (
        <>
            <BaseList
                columns={columns}
                fetchData={fetchData}
                reloadKey={reloadKey}
                itemName={itemName}
                listMode={listMode}
                useFrontendPagination={useFrontendPagination}
                disableSearch={disableSearch}
                onCardClick={onCardClick}
                onEdit={noChange ? null : handleOpenModal}
                onDelete={noChange ? null : ((item) => handleDelete(item.id))}
                customActions={customActions}
                defaultLogo={defaultLogo}
                actions={noChange ? null : actionGroup}
                expandable={expandable}
                excelImportExportOptions={excelImportExportOptions}
                onTableClick={onTableClick}
                renderContentCard={renderContentCard}
            />

            {!noChange && <BaseForm
                layout={layout}
                initialValues={editingItem || {}}
                apiPath={apiPath}
                itemName={itemName}
                additionalPostData={additionalPostData}
                submitLabel={editingItem ? "Cập nhật" : "Thêm"}
                visible={isModalVisible}
                onClose={handleCloseModal}
                dateFields={dateFields}
                onSuccess={() => {
                    reloadList();
                    handleCloseModal();
                }}
                patchMode
                onSubmitError={onSubmitError}
            />}
        </>
    );
};

export default Management;
